module.exports = __webpack_public_path__ + "static/media/ProximaNova-Bold.c25d0a8d.ttf";